import { Subscription } from "rxjs";
import { CaseFilterRequest, ProccessedCoassessCase, ProccessedCoreactCase, User } from "../interfaces";
import { WritableSignal, computed, inject, signal } from "@angular/core";
import { Roles, status } from "../utils";
import { UserService } from "../services";
import { ActivatedRoute, Router } from '@angular/router';




export class BaseCaseTable {
    protected userService = inject(UserService);
    protected router = inject(Router);
    protected route = inject(ActivatedRoute);

    stats = signal({
        total: 0
    });
    protected subscriptions: Subscription[] = [];
    loadingData: boolean = true;
    report: boolean = false;
    rows: (ProccessedCoassessCase | ProccessedCoreactCase)[] = [];
    currentUser: any;
    selected: any = [];

    users: User[] = [];
    cases: WritableSignal<(ProccessedCoassessCase | ProccessedCoreactCase)[]> = signal([]);

    currentUserRole: string = '';
    isDisabled: boolean = false;
    isDisabledManager: boolean = false;

    roles = Roles;
    selectedRow!: ProccessedCoassessCase | ProccessedCoreactCase;
    totalRows: number = 0;
    filterRequest: CaseFilterRequest = {} as CaseFilterRequest;



    caseManagerOptions = computed(() => this.userService.caseManagerOptions());
    investigatorOptions = computed(() => this.userService.investigatorOptions());



    getCurrentUserCases() {
        const allCases = this.cases();
        const user = this.currentUser();
        let filteredCases: any[] = [];

        if (user.role === 'Investigator') {
            filteredCases = allCases.filter(caseItem => this.isCurrentUserInvestigator(caseItem));
        } else if (user.role === 'CaseManager' && this.router.url.includes('coassess')) {
            filteredCases = allCases.filter(caseItem =>
                (caseItem as ProccessedCoassessCase).caseManager === `${user.firstName} ${user.lastName}`
            );
        } else if (user.role === 'Administrator') {
            filteredCases = allCases;
        }


        this.rows = filteredCases;
    }

    isCurrentUserInvestigator(caseItem: any): boolean {
        return (
            caseItem.investigator ===
            this.currentUser.firstName + ' ' + this.currentUser.lastName
        );
    }

    investigationResultsStatus(row: any) {
        if (row.isApproved == null) {
            if (row.isPending) {
                return status.PENDING;
            } else if (!row.isPending) {
                return status.UNDER_INVESTIGATION;
            }
        } else if (row.isApproved == false) {
            return status.REJECTED;
        } else {
            return status.APPROVED;
        }
        return '';
    }

    changePage(pageNumber: number) {
    }

    onRowsChange(updatedRows: (ProccessedCoassessCase | ProccessedCoreactCase)[]) {
        this.cases.set([...updatedRows]);
        this.rows = [...updatedRows];
    }

}